<template>
  <div class="english-profile-ai-card">
    <el-button
      class="ai-trigger-btn"
      :disabled="isGenerating"
      @click="openDialog"
    >
      <span class="sparkle">✨</span> AIに英文Profileを作ってもらう
    </el-button>

    <english-profile-ai-dialog
      :value="dialogVisible"
      :current-value="currentValue"
      @input="dialogVisible = $event"
      @adopt-profile="emit('adopt-profile', $event)"
      @update:generating="isGenerating = $event"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import EnglishProfileAiDialog from '@/components/yagiprime/EnglishProfileAiDialog.vue'

withDefaults(
  defineProps<{
    currentValue?: string
  }>(),
  {
    currentValue: ''
  }
)

const emit = defineEmits<{
  (e: 'adopt-profile', text: string): void
}>()

const dialogVisible = ref(false)
const isGenerating = ref(false)

function openDialog() {
  dialogVisible.value = true
}
</script>

<style scoped lang="scss">
.english-profile-ai-card {
  display: flex;
  justify-content: end;
  margin-bottom: 16px;
}

.ai-trigger-btn {
  background-color: #e3165c;
  border-color: #e3165c;
  color: #fff;
  font-weight: 700;
  padding: 12px;

  &:hover,
  &:focus {
    background-color: #c9135a;
    border-color: #c9135a;
    color: #fff;
  }

  &.is-disabled {
    background-color: #f4a4c3;
    border-color: #f4a4c3;
    color: #fff;
  }

  .sparkle {
    margin-right: 4px;
  }
}
</style>
